import { Component } from '@angular/core';
import { BannerComponent } from '@app/components/header/banner/banner.component';

@Component({
  selector: 'faxe-header',
  imports: [BannerComponent],
  template: `
    <header>
      <faxe-banner></faxe-banner>
    </header>
  `,
})
export class HeaderComponent {}
